import {Toast} from "primereact/toast";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCreditCard} from "@fortawesome/free-solid-svg-icons/faCreditCard";
import {Dropdown} from "primereact/dropdown";
import React, {useEffect, useRef, useState} from "react";
import {Button} from "primereact/button";
import axios from "axios";
import qs from "qs";
import {useDispatch, useSelector} from "react-redux";
import {InputText} from "primereact/inputtext";
import {updateGatewaySettings} from "../../../../Actions/MopriSettingActions";
import {FloatLabel} from "primereact/floatlabel";


const payGateStatuses = [{value: true, description: 'Active'}, {value: false, description: 'Inactive'}];
const payGateEnvironments = [{value: true, description: 'Sandbox Environment'}, {value: false, description: 'Live Environment'}];
const boolSelect = [{value: true, description: 'Yes'}, {value: false, description: 'No'}];

export const PayGateSettings = (props) => {
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false)
    const [payGateDetails, setPayGateDetails] = useState({
        payGateActive: false,
        payGateSandbox: false,
        payGateId: '',
        payGateIdSandbox: '',
        payGateEncryptionKey: '',
        payGateEncryptionKeySandbox: ''
    })

    const myToast = useRef(null)
    const gatewaySettings = useSelector(state => state.mopriSettings.gatewaySettings);
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);
    const themeSettings = useSelector(state => state.theme);
    const dispatch = useDispatch();

    useEffect(() => {
        if (gatewaySettings) {
            setPayGateDetails({
                payGateActive: gatewaySettings.payGateActive,
                payGateSandbox: gatewaySettings.payGateSandbox ? gatewaySettings.payGateSandbox : false,
                payGateId: gatewaySettings.payGateId,
                payGateIdSandbox: gatewaySettings.payGateIdSandbox,
                payGateEncryptionKey: gatewaySettings.payGateEncryptionKey,
                payGateEncryptionKeySandbox: gatewaySettings.payGateEncryptionKeySandbox,
            })
        }
    }, [gatewaySettings]);

    const handleOnChange = (e, field, type) => {
        if (type === 'dropdown') {
            setPayGateDetails({...payGateDetails, [field]: e.value});
        } else if (type === 'inputText') {
            setPayGateDetails({...payGateDetails, [field]: e.target.value});
        }
    }

    const updatePayGateSettings = () => {
        console.log(payGateDetails)
        setSubmitButtonDisabled(true)

        axios({
            method: 'post',
            url: `${apiURL}/api/gateway/updatePayGate`,
            data: qs.stringify({
                ...payGateDetails
            }),
            config: { headers: {'Content-Type': 'application/x-www-form-urlencoded' }}
        })
            .then((response) => {
                if (response && response.data.error) {
                    myToast.current.show({severity: 'error', summary: 'ERROR', detail: response.data.errorMessage, life: 5000});
                } else {
                    myToast.current.show({severity: 'success', summary: 'Success', detail: 'PayGate settings updated', life: 5000});
                    dispatch(updateGatewaySettings(payGateDetails))
                }
                setSubmitButtonDisabled(false)
            })
            .catch((e) => {
                setSubmitButtonDisabled(false)
                myToast.current.show({severity: 'error', summary: 'ERROR', detail: `An unexpected error took place`, life: 5000});
                console.log(e);
            });
    }


    return (
        <>
            <Toast ref={myToast}/>
            <div className="p-fluid grid formgrid">
                <div className="field col-12">
                    <h4><FontAwesomeIcon icon={faCreditCard} style={{paddingRight: '10px'}}/> PayGate Settings</h4>
                </div>
            </div>


            <div className="p-fluid grid formgrid">
                <div className="field col-12">

                        <div className="p-fluid grid formgrid">
                            <div className="field col-6">
                                <FloatLabel>
                                    <Dropdown value={payGateDetails?.payGateActive}
                                              options={payGateStatuses} optionLabel="description"
                                              optionValue="value"
                                              onChange={(e) => handleOnChange(e, 'payGateActive', 'dropdown')}
                                    />
                                    <label>PayGate Status</label>
                                </FloatLabel>
                            </div>
                            <div className="field col-6">
                                {payGateDetails?.payGateActive &&
                                    <>
                                        <FloatLabel>
                                            <Dropdown value={payGateDetails?.payGateSandbox}
                                                      options={payGateEnvironments} optionLabel="description"
                                                      optionValue="value"
                                                      onChange={(e) => handleOnChange(e, 'payGateSandbox', 'dropdown')}
                                            />
                                            <label>PayGate Sandbox Test Environment</label>
                                        </FloatLabel>
                                    </>
                                }
                            </div>
                        </div>

                        {(payGateDetails?.payGateActive && !payGateDetails?.payGateSandbox) &&
                            <>
                                <div className="p-fluid grid formgrid">
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <FloatLabel>
                                            <InputText value={payGateDetails?.payGateEncryptionKey}
                                                       onChange={(e) => handleOnChange(e, 'payGateEncryptionKey', 'inputText')}
                                            />
                                            <label htmlFor="payGateEncryptionKey">PayGate Encryption Key</label>
                                        </FloatLabel>
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <FloatLabel>
                                            <InputText value={payGateDetails?.payGateId}
                                                       onChange={(e) => handleOnChange(e, 'payGateId', 'inputText')}
                                            />
                                            <label htmlFor="payGateId">PayGate ID</label>
                                        </FloatLabel>
                                    </div>
                                </div>
                            </>
                        }

                        {(payGateDetails?.payGateActive && payGateDetails?.payGateSandbox) &&
                            <>
                                <div className="p-fluid grid formgrid">
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <FloatLabel>
                                            <InputText value={payGateDetails?.payGateEncryptionKeySandbox}
                                                       onChange={(e) => handleOnChange(e, 'payGateEncryptionKeySandbox', 'inputText')}
                                            />
                                            <label htmlFor="payGateEncryptionKeySandbox">PayGate Encryption Key (Sandbox)</label>
                                        </FloatLabel>
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <FloatLabel>
                                            <InputText value={payGateDetails?.payGateIdSandbox}
                                                       onChange={(e) => handleOnChange(e, 'payGateIdSandbox', 'inputText')}
                                            />
                                            <label htmlFor="payGateIdSandbox">PayGate ID (Sandbox)</label>
                                        </FloatLabel>
                                    </div>
                                </div>
                            </>
                        }
                </div>
            </div>

            <div className="col-12">
                <div className="p-fluid grid">
                    <div className="field col-12 md:col-9"></div>
                    <div className="field col-12 md:col-3">
                        <Button label="Update PayGate Settings"
                                severity="warning"
                                disabled={submitButtonDisabled}
                                style={themeSettings.buttonColor ? {background: `#${themeSettings.buttonColor}`} : {background: '#f97316'}}
                                onClick={() => updatePayGateSettings()}
                        />
                    </div>
                </div>
            </div>

        </>
    )
}